import type { ComponentChildren } from "preact"

/**
 * An icon rail with two slots: `top` from the top edge down, `bottom` pinned to
 * the foot. What goes in them is the caller's — the viewer's panels (see
 * {@link ViewerPanels}), a host's navigation and switches.
 */
export const ViewerRail = ({
  top,
  bottom,
}: {
  top: ComponentChildren
  bottom: ComponentChildren
}) => (
  <div className="flex h-full w-(--sidebar-width-icon) shrink-0 flex-col border-r p-2">
    {top}
    <div className="mt-auto flex flex-col items-center gap-1">{bottom}</div>
  </div>
)
